import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Does it work if I just started my degree or if I have been studying for years?',
  a: "It's the best time to build structure at any stage. If you're just starting, you build the right habits from day one. If you've been going for years, you reorganize, correct mistakes, and stop losing subjects to methods that simply don't work."
}, {
  q: 'How do I receive the material?',
  a: 'Immediately after payment you receive access to all 12 volumes and 5 bonuses in PDF format. No waiting, no shipping. Everything in your inbox within 5 minutes of purchase.'
}, {
  q: 'Does it actually work for the international university market?',
  a: 'Every technique, template and protocol has been designed specifically for the academic structure of USA, UK, Australian and Canadian universities. The examples, formats and strategies are fully adapted to the Anglo-Saxon university system.'
}, {
  q: 'Does it work for any degree or field of study?',
  a: 'Yes. Whether you are studying Medicine, Law, Engineering, Business, Arts or any other field. The system works on the method and the mindset, not on specific subject content.'
}, {
  q: 'Is the guarantee real?',
  a: 'Completely real. If within 7 days you feel the system did not deliver what was promised, you request your refund and receive 100% of your money back. No questions asked, no complications.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-ink" data-id="element-53" data-mp="rzb4uytkp5so">
      <div className="mx-auto max-w-3xl px-5 py-12" data-id="element-54" data-mp="rwyhg651q388">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-55" data-mp="wz7b74pqt9be">
          ❓ What People Ask Us Most
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-56" data-mp="j0hbdhbjgvjc">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-57" data-mp="2kvwz2i88jr4x" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:bg-white/[0.05]" data-id="element-58" data-mp="2kvn5ylrw93v0">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-59" data-mp="38j536wtxgu5d">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" data-id="element-60" data-mp="2ymsbg4hy0qd9" /> : <PlusIcon className="h-5 w-5 shrink-0 text-silver" data-id="element-61" data-mp="2ulzyp19v43c8" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-62" data-mp="1n8epx6anwn0e">
                  <div className="overflow-hidden" data-id="element-63" data-mp="3uug8y05ap3pp">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-64" data-mp="3uvr9zs7cvxd4">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}